var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreezer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.34 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "freezer"
  }, "Freezer Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "freezer"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.17,12.65l1.17-2.72L39.45.44,4.7,0l-1,3,9.05,8.89,3,.08v.52l-3.48-.08a.81.81,0,0,0-.31.06L.65,17.26h0a1.07,1.07,0,0,0-.22.15h0a.13.13,0,0,0,0,0,.83.83,0,0,0-.13.18l0,.09a.47.47,0,0,0,0,.17.43.43,0,0,1,0,.05V43a.74.74,0,0,0,.65.74l34.52,4.39h.09a.88.88,0,0,0,.32-.07l.08,0,.1-.06a.47.47,0,0,0,.06-.09s0,0,.06-.05l6.62-9.69a.72.72,0,0,0,.13-.42l.08-23.83h0s0-.05,0-.07l0-.15h0l0-.06a.54.54,0,0,0-.07-.13l-.06-.06a.24.24,0,0,0-.08-.09l-.08-.06-.07,0h0a.29.29,0,0,0-.1,0l-.12,0h0l-6-.14v-.48ZM6,2.93l32.13.44,4.27,7.3-29.16-.56ZM1.67,18.74l15.16.55,17.85.65V46.51l-33-4.19ZM41.3,37.44l-5.12,7.5V19.57l5.19-4.16Zm-6.12-19L4.32,17.34l8-3.4,27.71.61Zm-.5-5.53-17.49-.39V12l17.49.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezer);
export default __webpack_public_path__ + "static/media/freezer.3165c882fb2c5d0d2e057733832da497.svg";
export { ForwardRef as ReactComponent };